import { render, staticRenderFns } from "./SignatureIndicators.vue?vue&type=template&id=1dbc9c6b&scoped=true"
import script from "./SignatureIndicators.vue?vue&type=script&lang=js"
export * from "./SignatureIndicators.vue?vue&type=script&lang=js"
import style0 from "./SignatureIndicators.vue?vue&type=style&index=0&id=1dbc9c6b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc9c6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dbc9c6b')) {
      api.createRecord('1dbc9c6b', component.options)
    } else {
      api.reload('1dbc9c6b', component.options)
    }
    module.hot.accept("./SignatureIndicators.vue?vue&type=template&id=1dbc9c6b&scoped=true", function () {
      api.rerender('1dbc9c6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/term/SignatureIndicators.vue"
export default component.exports